import { FeaturedDealers } from "../components/blocks/featured-dealers";
import {
  VinoDataImage,
  generateStorefrontImage,
} from "../utils/generate-storefront-image";

interface ContentfulDealer {
  name: string;
  profileImage: VinoDataImage;
  blurb?: string;
  likes?: string;
  dislikes?: string;
}

interface ContentfulDealerFeatureBlockProps {
  __typename: string;
  dealers: Array<ContentfulDealer>;
}

const test = ({ __typename }: ContentfulDealerFeatureBlockProps): boolean =>
  __typename === "VinoData_DealerFeatureBlock";

const create = (data: ContentfulDealerFeatureBlockProps): JSX.Element => {
  const transformedData = {
    ...data,
    dealers: data.dealers.map((dealer) => ({
      ...dealer,
      image: generateStorefrontImage(dealer.profileImage),
    })),
  };
  return <FeaturedDealers {...transformedData} />;
};

export default { test, create };
